import { render, staticRenderFns } from "./retention-time.vue?vue&type=template&id=46f51f98&scoped=true&"
import script from "./retention-time.vue?vue&type=script&lang=ts&"
export * from "./retention-time.vue?vue&type=script&lang=ts&"
import style0 from "./retention-time.vue?vue&type=style&index=0&id=46f51f98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f51f98",
  null
  
)

export default component.exports